import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../core/services/auth.service';
import { UserConfigurationService } from '../../core/services/user-configuration.service';

@Component({
  selector: 'osp-app-home-redirect',
  template: '<div>Redirecting...</div>',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HomeRedirectComponent implements OnInit {
  private readonly activatedRoute = inject(ActivatedRoute);
  private readonly authService = inject(AuthService);
  private readonly userConfigurationService = inject(UserConfigurationService);
  private readonly router = inject(Router);

  ngOnInit(): void {
    const homepage = this.authService.isSuperOrPartnerAdmin()
      ? '/administration/management/customers'
      : this.userConfigurationService.getSetting('homepage') || '/resources/equipment/list';
    const urlTree = this.router.parseUrl(homepage);
    urlTree.queryParams = { ...this.activatedRoute.snapshot.queryParams, ...urlTree.queryParams };
    this.router.navigateByUrl(urlTree);
  }
}
